import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"

import SpriteAnimation from "@frog/source/juice/utility/SpriteAnimation.js"
import "@frog/source/views/components/UnitSprite.less"

import unitsprites from "@frog/source/data/unitsprites.js"
import unitJobs from "@frog/source/data/unit-jobs.js"
import games from "@frog/source/data/games/index.js"

const DEFAULT_AFFILIATION = "bad"
const DEFAULT_FACE_KEY = "human"

export default class UnitSprite {
    render() {
        if(this.props.unit == undefined) return
        if((this.props.unit.type == "zone" || this.props.unit.type == "spot")
        && this.props.unit.properties?.includes("visible") != true) {
            return (
                <div class="LegacySpot"/>
            )
        }
        const isBig = (this.props.unit.element == App.game?.chapter?.selection?.hoveredElementKey && this.props.unit.element != undefined)
            || (this.props.unit.equippedItem?.element == App.game?.chapter?.selection?.hoveredElementKey && this.props.unit.equippedItem?.element != undefined)

        return (
            <div class="UnitSprite" key={this.props.unit.key} isGrayscaled={this.props.isGrayscaled}
                isHighlighted={this.props.isHighlighted}
                imageSize={this.props.unit.imageSize}
                style={{"background-image": this.imageUrl && "url(" + this.imageUrl + ")"}}>
                {this.shadow}
                <div class="Body" style={{
                    "background-image": this.bodyUrl() && "url(" + this.bodyUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
                <div class="Face" style={{
                    "background-image": this.faceUrl() && "url(" + this.faceUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
                <div class="Decal" style={{
                    "background-image": this.decalUrl() && "url(" + this.decalUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
                <div class="Weapon" isHidden={this.props.unit.affiliation == "none"}
                    isBig={isBig} style={{
                    "background-image": this.weaponUrl() && "url(" + this.weaponUrl() + ")",
                    "animation-name": this.animationName,
                    "animation-delay": this.animationDelay,
                }}/>
            </div>
        )
    }
    get shadow() {
        if(App.game.slug != "ember") return
        if(this.props.unit.imageSize != "contained") return
        return [
            <div class="Shadow"/>,
            <div class="Glow"/>,
        ]
    }
    get animationName() {
        if(App.game?.configuration?.squigglevision == true
        && Dev.inProtoMode != true
        && this.props.abortSquigglevision != true) {
            return "squigglevision"
        }
    }
    get animationDelay() {
        if(this.props.unit.affiliation == "bad") {
            return "0s"
        } else {
            return "0.5s"
        }
    }
    getUnitProperty(property) {
        const partyUnit = (games[App.game?.slug]?.player?.party?.units || {})[this.props.unit.key]
        if(partyUnit != undefined) {
            if(partyUnit[property] != undefined) {
                return partyUnit[property]
            }
            if(partyUnit.jobKey != undefined
            && unitJobs[partyUnit.jobKey] != undefined
            && unitJobs[partyUnit.jobKey][property] != undefined) {
                return unitJobs[partyUnit.jobKey][property]
            }
        }
        if(this.props.unit.jobKey != undefined
        && unitJobs[this.props.unit.jobKey] != undefined
        && unitJobs[this.props.unit.jobKey][property] != undefined) {
            return unitJobs[this.props.unit.jobKey][property]
        }
        if(this.props.unit.randomJobKey != undefined) {
            const possibleJobKeys = this.props.unit.randomJobKey.split(",").map((jobKey) => jobKey.trim())
            const randomizedJobKey = possibleJobKeys[Math.floor(Date.now()/1000) % possibleJobKeys.length]
            if(unitJobs[randomizedJobKey] != undefined
            && unitJobs[randomizedJobKey][property] != undefined) {
                return unitJobs[randomizedJobKey][property]
            }
        }
    }
    bodyUrl() {
        if(this.imageUrl != undefined) return
        let protoBodyKey = undefined
        if(Dev.inProtoMode == true) {
            protoBodyKey = this.getUnitProperty("bodyKey")
        }
        return this.props.unit.body || unitsprites.bodies[protoBodyKey || this.props.unit.bodyKey || this.props.unit.affiliation || DEFAULT_AFFILIATION]
    }
    faceUrl() {
        if(this.imageUrl != undefined) return
        let protoFace = undefined
        let protoFaceKey = undefined
        if(Dev.inProtoMode == true) {
            protoFace = this.getUnitProperty("face")
            protoFaceKey = this.getUnitProperty("faceKey")
        }
        return this.props.unit.face || protoFace || unitsprites.faces[this.props.unit.faceKey || protoFaceKey || DEFAULT_FACE_KEY]
    }
    decalUrl() {
        if(this.props.unit.affiliation == "none") {
            return unitsprites.decals["jail"]
        }
        if(this.getUnitProperty("decalImageKey") != undefined) {
            return unitsprites.decals[this.getUnitProperty("decalImageKey")]
        }
    }
    weaponUrl() {
        let protoWeaponImageKey = undefined
        if(this.props.unit.state == "pacified") return
        if(Dev.inProtoMode == true) {
            protoWeaponImageKey = this.getUnitProperty("weaponImageKey") || this.getUnitProperty("primaryItem")?.weaponImageKey
        }
        return unitsprites.weapons[protoWeaponImageKey || this.props.unit.equippedItem?.weaponImageKey || this.props.unit.cachedProperties?.primaryItem?.weaponImageKey || this.props.unit.weaponImageKey]
    }
    get imageUrl() {
        const unit = this.props.unit

        if(unit.imageKey != undefined
        && unitsprites.images[unit.imageKey] != undefined) {
            return unitsprites.images[unit.imageKey]
        }

        if(unit.spriteKey != undefined
        && unit.sprites != undefined
        && unit.sprites[unit.spriteKey] != undefined) {
            return unit.sprites[unit.spriteKey]
        }

        if(unit.imageUrl != undefined) return unit.imageUrl

        if(unit.sprites == undefined) return

        if(unit.affiliation == "good"
        && unit.energy != undefined
        && unit.energy["invoke skill"] != false) {
            if(unit.sprites?.moving != undefined
            && App.game?.chapter?.selection?.selectedUnitKey == unit.key) {
                return SpriteAnimation.getImage({
                    "animation": unit.sprites.moving
                })
            }

            if(unit.sprites?.ready != undefined
            && (App.game?.chapter?.selection?.hoveredUnitKey == unit.key
            || App.game?.chapter?.selection?.selectedUnitKey == unit.key)) {
                return SpriteAnimation.getImage({
                    "animation": unit.sprites.ready,
                    "startTimestamp": App.game?.chapter?.selection?.hoveredTimestamp
                })
            }
        }

        if(unit.sprites?.idle != undefined) {
            return SpriteAnimation.getImage({
                "animation": unit.sprites.idle
            })
        }
        if(unit.sprites.static != undefined) {
            return unit.sprites.static
        }
    }
    get paletteKey() {
        if(this.props.unit.affiliation == "bad") {
            return "red"
        } else {
            return "blue"
        }
    }
}
